<script setup lang="ts">
import { ref, nextTick } from 'vue'
import IconComponent from './IconComponent.vue';
import { clickOutside } from '../../../directives/clickOutside'

const props = defineProps<{
  text?: string
  icon?: string
  hideArrow?: boolean
  isFab?: boolean
  count?: number | 0
  className?: string
  disabled?: boolean
  allowButtonClick?: boolean
}>()

const isOpen = ref(false);
const dropdownTop = ref(0);
const dropdownRight = ref<number | null>(null);
const dropdownBottom = ref<number | null>(null);
const dropdownLeft = ref<number | null>(null);
const buttonRef = ref<HTMLElement | null>(null);


const emit = defineEmits<{
  (e: 'buttonClick'): void
}>()
const handleButtonClick = () => {
  if (props.disabled) return;
  if (props.allowButtonClick) {
    emit('buttonClick')
  } else {
    toggleDropdown()
  }
};
const toggleDropdown = async () => {
  if (props.disabled) return;
  isOpen.value = !isOpen.value;
  if (isOpen.value && buttonRef.value) {
    await nextTick(); // Ensure DOM updates before getting position

    const rect = buttonRef.value.getBoundingClientRect();
    dropdownTop.value = rect.bottom + window.scrollY; // Position dropdown below the button
    console.log('Dropdown Top:', dropdownTop.value);
    console.log('rect', rect);
    console.log('window.innerWidth', window.innerWidth);
    console.log('window.innerHeight', window.innerHeight);

    if (window.innerWidth - rect.right > 200) { // 200 is an arbitrary value to check if there's enough space
      dropdownLeft.value = rect.left; // Align dropdown to the left of the button
      dropdownRight.value = null;
    } else {
      dropdownRight.value = window.innerWidth - rect.right; // Align dropdown to the right of the button
      dropdownLeft.value = null;
      dropdownBottom.value = null;
    }

    if ((window.innerHeight - rect.y) < 200) { // Check if there's enough space below the button
      dropdownTop.value = 0; // Adjust dropdown position to above the button
      dropdownBottom.value = 60; // Position dropdown above the button
    }
  }
};

const closeDropdown = () => {
  isOpen.value = false
}

defineOptions({
  directives: {
    'click-outside': clickOutside,
  },
})

</script>

<template>
  <div class="relative inline-block text-left" v-click-outside="closeDropdown">
    <button
      ref="buttonRef"
      @click="handleButtonClick"
      class="p-2 transition-all duration-200 flex items-center justify-center hover:bg-gray-600 group"
      :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
      :class="[
        'transition-all duration-200 flex items-center justify-center group',
        isFab ? 'fixed right-2 w-10 h-10 bg-red-600 rounded-full text-white shadow-lg z-[1000]' : 'p-2 rounded-lg hover:bg-gray-600',
        className || '',
      ]"
    >
      <IconComponent :name="props.icon || 'EllipsisVertical'" class="text-gray dark:text-white"  />
      <span v-if="text">{{ text }}</span>
      <span v-if="!hideArrow" @click="handleButtonClick" class="text-gray-400 ml-1">▼</span>
      <span
        v-if="props.count && props.count > 0"
        class="absolute top-0 right-0 inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-blue-600 rounded-full -mt-1 -mr-1"
      >
        {{ props.count }}
      </span>
    </button>

    <teleport to="body">
      <div
        v-if="isOpen"
        ref="dropdownRef"
        class="absolute w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-[1000]"
        :style="{ top: !dropdownBottom ? dropdownTop + 'px' : '', bottom: dropdownBottom + 'px', right: dropdownRight !== null ? dropdownRight + 'px' : 'auto', left: dropdownLeft !== null ? dropdownLeft + 'px' : 'auto' }"
      >
        <slot></slot>
      </div>
    </teleport>
  </div>
</template>